// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var RequestLogsWebController = function ($scope, $routeParams, RequestLogsWeb) {
    $scope.before = $routeParams.before ? $routeParams.before : null;
    $scope.after = $routeParams.after ? $routeParams.after : null;
    $scope.logSource = 'Log';

    $scope.loadLogs = function () {
        $scope.activeSearchQuery = $scope.searchQuery;
        $scope.logs = [];
        $scope.maxId = null;
        $scope.loadNext();
    };

    $scope.loadNext = function () {
        RequestLogsWeb.query({ searchQuery: $scope.activeSearchQuery, before: $scope.before, max: $scope.maxId, entity: $scope.entity, logmini: ($scope.logSource === 'Log' ? false : true), after: $scope.after }, function (data) {
            $scope.logs = $scope.logs.concat(data);
            if (data.length > 0)
                $scope.maxId = data[data.length - 1].Id;
            else
                $scope.maxId = "000000000000000000000000";
        });
    };

    $scope.transferLog = function (response) {
        var data = null;
        try {
            data = JSON.parse(response);
        } catch (ex) {
            data = "";
        }
        return data;
    };

    $scope.loadLogs();
};
RequestLogsWebController.$inject = ['$scope', '$routeParams', 'RequestLogsWeb'];
